import { useMaybeKycContext } from '../context/kyc-context';
import { IdnowLoading } from './idnow-loading';
import { FourthlineLoading } from './fourthline-loading';

interface KycPageLoadingProps {
  legalCountry?: string;
  isFullHeight?: boolean;
}

export function KycPageLoading({
  legalCountry,
  isFullHeight = true,
}: KycPageLoadingProps): React.ReactNode {
  const context = useMaybeKycContext();
  return context?.legalCountry === 'DE' || legalCountry === 'DE' ? (
    <IdnowLoading isFullHeight={isFullHeight} />
  ) : (
    <FourthlineLoading isFullHeight={isFullHeight} />
  );
}
